import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0607b3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid m-0 p-0" }
const _hoisted_2 = { class: "analysis-container" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3 text-muted" }, "Loading your interview analysis...", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "analysis-header text-center mb-5" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "display-6 mb-3" }, "Interview Analysis"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted lead" }, "Here's a detailed breakdown of your interview performance")
], -1))
const _hoisted_8 = {
  key: 0,
  class: "row g-4 mb-4"
}
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "card overall-performance-card" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "card-title mb-4" }, "Overall Performance", -1))
const _hoisted_13 = { class: "overall-score-section mb-4" }
const _hoisted_14 = { class: "score-gauge" }
const _hoisted_15 = { class: "circle-progress" }
const _hoisted_16 = {
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "50",
  cy: "50",
  r: "45",
  fill: "none",
  stroke: "#e2e8f0",
  "stroke-width": "10"
}, null, -1))
const _hoisted_18 = ["stroke", "stroke-dashoffset"]
const _hoisted_19 = { class: "circle-content" }
const _hoisted_20 = { class: "score-value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "score-label" }, "Score", -1))
const _hoisted_22 = { class: "overall-feedback" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-quote me-2 text-primary" }, null, -1))
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-8" }
const _hoisted_26 = { class: "talk-time-stats" }
const _hoisted_27 = { class: "talk-time-circle" }
const _hoisted_28 = { class: "circle-progress" }
const _hoisted_29 = {
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "50",
  cy: "50",
  r: "45",
  fill: "none",
  stroke: "#e2e8f0",
  "stroke-width": "10"
}, null, -1))
const _hoisted_31 = ["stroke", "stroke-dashoffset"]
const _hoisted_32 = { class: "circle-content" }
const _hoisted_33 = { class: "talk-time-ratio" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "talk-time-label" }, "Talk Time", -1))
const _hoisted_35 = { class: "talk-time-details" }
const _hoisted_36 = { class: "talk-time-item" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-fill text-primary" }),
  /*#__PURE__*/_createTextVNode(" Your Talk Time ")
], -1))
const _hoisted_38 = { class: "item-value" }
const _hoisted_39 = { class: "talk-time-item" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-video3 text-primary" }),
  /*#__PURE__*/_createTextVNode(" Interviewer Talk Time ")
], -1))
const _hoisted_41 = { class: "item-value" }
const _hoisted_42 = { class: "col-md-4" }
const _hoisted_43 = { class: "overall-stats" }
const _hoisted_44 = { class: "stat-card" }
const _hoisted_45 = { class: "stat-icon" }
const _hoisted_46 = { class: "stat-content" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Overall Sentiment", -1))
const _hoisted_48 = { class: "stat-value" }
const _hoisted_49 = { class: "stat-card" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chat-dots-fill text-primary" })
], -1))
const _hoisted_51 = { class: "stat-content" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Filler Words Used", -1))
const _hoisted_53 = { class: "stat-value" }
const _hoisted_54 = {
  key: 1,
  class: "row g-4"
}
const _hoisted_55 = { class: "card h-100 question-card" }
const _hoisted_56 = { class: "card-body" }
const _hoisted_57 = ["onClick", "aria-expanded"]
const _hoisted_58 = { class: "d-flex align-items-center gap-3" }
const _hoisted_59 = { class: "question-number" }
const _hoisted_60 = { class: "question-content mb-4" }
const _hoisted_61 = { class: "question-text" }
const _hoisted_62 = { class: "answer-section" }
const _hoisted_63 = { class: "answer-content mb-4" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-muted mb-2" }, "Your Answer:", -1))
const _hoisted_65 = { class: "answer-text" }
const _hoisted_66 = { class: "exemplar-content mb-4" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "exemplar-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill text-success me-2" }),
  /*#__PURE__*/_createTextVNode(" Example Strong Answer ")
], -1))
const _hoisted_68 = { class: "exemplar-text" }
const _hoisted_69 = { class: "metrics-section mb-4" }
const _hoisted_70 = { class: "metrics-grid" }
const _hoisted_71 = { class: "metric-card" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "metric-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-text-paragraph text-primary" }),
  /*#__PURE__*/_createElementVNode("span", null, "Word Count")
], -1))
const _hoisted_73 = { class: "metric-value" }
const _hoisted_74 = { class: "metric-card" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "metric-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bar-chart-fill text-primary" }),
  /*#__PURE__*/_createElementVNode("span", null, "Clarity Score")
], -1))
const _hoisted_76 = { class: "clarity-score" }
const _hoisted_77 = { class: "progress" }
const _hoisted_78 = {
  key: 0,
  class: "metric-card"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "metric-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-emoji-smile-fill text-success" }),
  /*#__PURE__*/_createElementVNode("span", null, "Strong Response")
], -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "metric-value" }, "Clear & Detailed", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "metric-context text-success" }, " Your answer was well-structured ", -1))
const _hoisted_82 = [
  _hoisted_79,
  _hoisted_80,
  _hoisted_81
]
const _hoisted_83 = { class: "feedback-section" }
const _hoisted_84 = { class: "feedback-column" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "feedback-title text-success" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill me-2" }),
  /*#__PURE__*/_createTextVNode("Strengths ")
], -1))
const _hoisted_86 = { class: "feedback-list strengths" }
const _hoisted_87 = { class: "feedback-column" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "feedback-title text-warning" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lightbulb-fill me-2" }),
  /*#__PURE__*/_createTextVNode("Areas for Improvement ")
], -1))
const _hoisted_89 = { class: "feedback-list improvements" }

import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import BreadcrumbNav from "@/components/BreadcrumbNav.vue";
import VChart from "vue-echarts";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart, BarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from "echarts/components";
import { toast } from "vue3-toastify";

// Register ECharts components
interface TalkTime {
  interviewer: number;
  interviewee: number;
}

interface OverallMetrics {
  totalTalkTime: TalkTime;
  overallSentiment: "Positive" | "Neutral" | "Negative";
  fillerWordCount: number;
  overallScore: number;
  overallSummary: string;
}

interface QuestionAnalysis {
  question: string;
  type: "Technical" | "Behavioral" | "General" | "Situational";
  complexity: "Easy" | "Moderate" | "Hard" | "Difficult";
  expectedAnswer: string;
}

interface AnswerAnalysis {
  answer: string;
  wordCount: number;
  clarityScore: number;
  usesSTAR: boolean;
  examplarResponse: string;
}

interface Feedback {
  strengths: string[];
  improvements: string[];
}

interface Question {
  questionAnalysis: QuestionAnalysis;
  answerAnalysis: AnswerAnalysis;
  feedback: Feedback;
}

interface AnalysisResults {
  applicationId: string;
  userId: string;
  questions: Question[];
  overallMetrics: OverallMetrics;
  overallScore: number;
  overallFeedback: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InterviewAnalysis',
  setup(__props) {

use([
  CanvasRenderer,
  PieChart,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
]);

const route = useRoute();
const router = useRouter();
const analysis = ref<AnalysisResults | null>(null);
const expandedAnswers = ref<boolean[]>([]);
const isLoading = ref(true);

onMounted(() => {
  // Get analysis from local storage
  const storedAnalysis = localStorage.getItem("interviewAnalysis");
  if (storedAnalysis) {
    try {
      analysis.value = JSON.parse(storedAnalysis);
      // Initialize expandedAnswers array with false values for each question
      if (analysis.value && analysis.value.questions) {
        expandedAnswers.value = new Array(analysis.value.questions.length).fill(false);

        // Only remove old analysis if there's already one stored for this application
        const applicationSpecificKey = `interviewAnalysis_${analysis.value.applicationId}`;
        const existingAnalysis = localStorage.getItem(applicationSpecificKey);
        if (existingAnalysis) {
          localStorage.removeItem("interviewAnalysis");
          localStorage.removeItem(applicationSpecificKey);
        }
      }
    } catch (error) {
      console.error("Error parsing interview analysis:", error);
      toast.error("Error loading interview analysis");
      router.push("/");
    } finally {
      isLoading.value = false;
    }
  } else {
    toast.error("No interview analysis found");
    router.push("/");
  }
});

const toggleAnswer = (index: number) => {
  expandedAnswers.value[index] = !expandedAnswers.value[index];
};

const overallMetricsChartOption = computed(() => ({
  tooltip: {
    trigger: "axis",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    borderWidth: 0,
    textStyle: { color: "#333" },
    extraCssText: "box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);",
  },
  grid: {
    left: "3%",
    right: "4%",
    bottom: "3%",
    containLabel: true,
  },
  xAxis: {
    type: "category",
    data: ["Interviewer Talk Time", "Interviewee Talk Time"],
    axisLine: { lineStyle: { color: "#eee" } },
    axisTick: { show: false },
  },
  yAxis: {
    type: "value",
    splitLine: { lineStyle: { color: "#eee" } },
    axisLine: { show: false },
    axisTick: { show: false },
  },
  series: [
    {
      type: "bar",
      data: [
        {
          value: analysis.value?.overallMetrics?.totalTalkTime?.interviewer || 0,
          itemStyle: { color: "#87CEEB" },
        },
        {
          value: analysis.value?.overallMetrics?.totalTalkTime?.interviewee || 0,
          itemStyle: { color: "#4682B4" },
        },
      ],
      itemStyle: {
        borderRadius: [4, 4, 0, 0],
      },
    },
  ],
}));

const getQuestionChartOption = (question: any) => ({
  tooltip: {
    trigger: "axis",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    borderWidth: 0,
    textStyle: { color: "#333" },
    extraCssText: "box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);",
  },
  grid: {
    left: "3%",
    right: "4%",
    bottom: "3%",
    containLabel: true,
  },
  xAxis: {
    type: "category",
    data: ["Word Count", "Clarity Score"],
    axisLine: { lineStyle: { color: "#eee" } },
    axisTick: { show: false },
  },
  yAxis: {
    type: "value",
    splitLine: { lineStyle: { color: "#eee" } },
    axisLine: { show: false },
    axisTick: { show: false },
  },
  series: [
    {
      type: "bar",
      data: [
        {
          value: question.answerAnalysis.wordCount,
          itemStyle: { color: "#87CEEB" },
        },
        {
          value: question.answerAnalysis.clarityScore,
          itemStyle: { color: "#4682B4" },
        },
      ],
      itemStyle: {
        borderRadius: [4, 4, 0, 0],
      },
    },
  ],
});

const getSentimentClass = (sentiment: "Positive" | "Neutral" | "Negative") => {
  const classes = {
    Positive: "text-success",
    Neutral: "text-warning",
    Negative: "text-danger",
  } as const;
  return classes[sentiment] || "text-primary";
};

const getQuestionTypeClass = (type: QuestionAnalysis["type"]) => {
  const classes = {
    Technical: "type-technical",
    Behavioral: "type-behavioral",
    General: "type-general",
    Situational: "type-behavioral", // Treat Situational as Behavioral for styling
  } as const;
  return classes[type] || "type-general";
};

const getComplexityClass = (complexity: QuestionAnalysis["complexity"]) => {
  const classes = {
    Easy: "complexity-easy",
    Moderate: "complexity-moderate",
    Hard: "complexity-hard",
    Difficult: "complexity-hard", // Treat Difficult as Hard for styling
  } as const;
  return classes[complexity] || "complexity-moderate";
};

const getWordCountContext = (wordCount: number) => {
  if (wordCount < 50) return "Too brief - aim for more detail";
  if (wordCount > 200) return "Consider being more concise";
  return "Good length";
};

const getWordCountClass = (wordCount: number) => {
  if (wordCount < 50) return "text-warning";
  if (wordCount > 200) return "text-warning";
  return "text-success";
};

const getClarityScoreClass = (score: number) => {
  if (score < 40) return "bg-danger";
  if (score < 70) return "bg-warning";
  return "bg-success";
};

const getTalkTimeClass = (role: "interviewer" | "interviewee") => {
  if (!analysis.value) return "";

  const intervieweeTalkTime = analysis.value.overallMetrics.totalTalkTime.interviewee;
  const interviewerTalkTime = analysis.value.overallMetrics.totalTalkTime.interviewer;
  const totalTime = intervieweeTalkTime + interviewerTalkTime;

  const intervieweeRatio = intervieweeTalkTime / totalTime;

  if (role === "interviewee") {
    if (intervieweeRatio < 0.4) return "text-warning";
    if (intervieweeRatio > 0.8) return "text-warning";
    return "text-success";
  } else {
    if (intervieweeRatio < 0.4) return "text-success";
    if (intervieweeRatio > 0.8) return "text-warning";
    return "text-success";
  }
};

const getTalkTimeContext = (role: "interviewer" | "interviewee") => {
  if (!analysis.value) return "";

  const intervieweeTalkTime = analysis.value.overallMetrics.totalTalkTime.interviewee;
  const interviewerTalkTime = analysis.value.overallMetrics.totalTalkTime.interviewer;
  const totalTime = intervieweeTalkTime + interviewerTalkTime;

  const intervieweeRatio = intervieweeTalkTime / totalTime;

  if (role === "interviewee") {
    if (intervieweeRatio < 0.4) return "Try to provide more detailed answers";
    if (intervieweeRatio > 0.8) return "Consider being more concise";
    return "Good balance of talk time";
  }
};

const getTalkTimeRatio = () => {
  if (!analysis.value) return 0;
  const total =
    analysis.value.overallMetrics.totalTalkTime.interviewee +
    analysis.value.overallMetrics.totalTalkTime.interviewer;
  return analysis.value.overallMetrics.totalTalkTime.interviewee / total;
};

const getTalkTimeOffset = () => {
  const ratio = getTalkTimeRatio();
  const circumference = 2 * Math.PI * 45; // r = 45
  return circumference * (1 - ratio);
};

const getTalkTimeColor = () => {
  const ratio = getTalkTimeRatio();
  if (ratio < 0.4) return "#fbbf24"; // warning yellow
  if (ratio > 0.8) return "#fbbf24"; // warning yellow
  return "#22c55e"; // success green
};

const getScoreOffset = () => {
  if (!analysis.value) return 282.7; // Full circle circumference
  const score = analysis.value.overallMetrics.overallScore;
  const percentage = Math.min(Math.max(score, 0), 100) / 100;
  const circumference = 2 * Math.PI * 45; // r = 45
  return circumference * (1 - percentage);
};

const getScoreColor = (score: number) => {
  if (score >= 80) return "#22c55e"; // success green
  if (score >= 60) return "#0d6efd"; // primary blue
  if (score >= 40) return "#fbbf24"; // warning yellow
  return "#ef4444"; // danger red
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BreadcrumbNav, {
      "back-link": `/application/${_unref(route).params.id}`,
      "back-text": "Application",
      "current-page": "Interview Analysis"
    }, null, 8, ["back-link"]),
    _createElementVNode("div", _hoisted_2, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_7,
            (analysis.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_16, [
                                _hoisted_17,
                                _createElementVNode("circle", {
                                  cx: "50",
                                  cy: "50",
                                  r: "45",
                                  fill: "none",
                                  stroke: getScoreColor(analysis.value.overallMetrics.overallScore),
                                  "stroke-width": "10",
                                  "stroke-dasharray": "282.7",
                                  "stroke-dashoffset": getScoreOffset(),
                                  transform: "rotate(-90 50 50)"
                                }, null, 8, _hoisted_18)
                              ])),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, _toDisplayString(analysis.value.overallMetrics.overallScore), 1),
                                _hoisted_21
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createTextVNode(" " + _toDisplayString(analysis.value.overallMetrics.overallFeedback), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_29, [
                                    _hoisted_30,
                                    _createElementVNode("circle", {
                                      cx: "50",
                                      cy: "50",
                                      r: "45",
                                      fill: "none",
                                      stroke: getTalkTimeColor(),
                                      "stroke-width": "10",
                                      "stroke-dasharray": "282.7",
                                      "stroke-dashoffset": getTalkTimeOffset(),
                                      transform: "rotate(-90 50 50)"
                                    }, null, 8, _hoisted_31)
                                  ])),
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, _toDisplayString(Math.round(getTalkTimeRatio() * 100)) + "% ", 1),
                                    _hoisted_34
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _hoisted_37,
                                  _createElementVNode("div", _hoisted_38, _toDisplayString(Math.round(analysis.value.overallMetrics.totalTalkTime.interviewee / 60)) + " min ", 1)
                                ]),
                                _createElementVNode("div", _hoisted_39, [
                                  _hoisted_40,
                                  _createElementVNode("div", _hoisted_41, _toDisplayString(Math.round(analysis.value.overallMetrics.totalTalkTime.interviewer / 60)) + " min ", 1)
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["talk-time-feedback", getTalkTimeClass('interviewee')])
                                }, _toDisplayString(getTalkTimeContext("interviewee")), 3)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["bi bi-emoji-smile-fill", getSentimentClass(analysis.value.overallMetrics.overallSentiment)])
                                  }, null, 2)
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _hoisted_47,
                                  _createElementVNode("div", _hoisted_48, _toDisplayString(analysis.value.overallMetrics.overallSentiment), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_49, [
                                _hoisted_50,
                                _createElementVNode("div", _hoisted_51, [
                                  _hoisted_52,
                                  _createElementVNode("div", _hoisted_53, _toDisplayString(analysis.value.overallMetrics.fillerWordCount), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (analysis.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysis.value.questions, (question, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-12",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("div", {
                            class: "question-header mb-4 d-flex justify-content-between align-items-center cursor-pointer",
                            onClick: ($event: any) => (toggleAnswer(index)),
                            role: "button",
                            "aria-expanded": expandedAnswers.value[index]
                          }, [
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("span", _hoisted_59, "Q" + _toDisplayString(index + 1), 1),
                              _createElementVNode("div", {
                                class: _normalizeClass(["question-type-badge", getQuestionTypeClass(question.questionAnalysis.type)])
                              }, _toDisplayString(question.questionAnalysis.type), 3),
                              _createElementVNode("div", {
                                class: _normalizeClass(["complexity-badge", getComplexityClass(question.questionAnalysis.complexity)])
                              }, _toDisplayString(question.questionAnalysis.complexity), 3)
                            ]),
                            _createElementVNode("i", {
                              class: _normalizeClass(["bi", expandedAnswers.value[index] ? 'bi-chevron-up' : 'bi-chevron-down'])
                            }, null, 2)
                          ], 8, _hoisted_57),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("p", _hoisted_61, _toDisplayString(question.questionAnalysis.question), 1)
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _hoisted_64,
                              _createElementVNode("p", _hoisted_65, _toDisplayString(question.answerAnalysis.answer), 1)
                            ]),
                            _createElementVNode("div", _hoisted_66, [
                              _hoisted_67,
                              _createElementVNode("div", _hoisted_68, _toDisplayString(question.answerAnalysis.examplarResponse), 1)
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("div", _hoisted_71, [
                                  _hoisted_72,
                                  _createElementVNode("div", _hoisted_73, _toDisplayString(question.answerAnalysis.wordCount), 1),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["metric-context", getWordCountClass(question.answerAnalysis.wordCount)])
                                  }, _toDisplayString(getWordCountContext(question.answerAnalysis.wordCount)), 3)
                                ]),
                                _createElementVNode("div", _hoisted_74, [
                                  _hoisted_75,
                                  _createElementVNode("div", _hoisted_76, [
                                    _createElementVNode("div", _hoisted_77, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["progress-bar", getClarityScoreClass(question.answerAnalysis.clarityScore)]),
                                        role: "progressbar",
                                        style: _normalizeStyle({ width: question.answerAnalysis.clarityScore + '%' })
                                      }, _toDisplayString(question.answerAnalysis.clarityScore) + "% ", 7)
                                    ])
                                  ])
                                ]),
                                (question.answerAnalysis.clarityScore >= 70)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, _hoisted_82))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_83, [
                              _createElementVNode("div", _hoisted_84, [
                                _hoisted_85,
                                _createElementVNode("ul", _hoisted_86, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.feedback.strengths, (strength, idx) => {
                                    return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(strength), 1))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_87, [
                                _hoisted_88,
                                _createElementVNode("ul", _hoisted_89, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.feedback.improvements, (improvement, idx) => {
                                    return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(improvement), 1))
                                  }), 128))
                                ])
                              ])
                            ])
                          ], 512), [
                            [_vShow, expandedAnswers.value[index]]
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 64))
    ])
  ]))
}
}

})